import { createRoot } from 'react-dom/client';
import App from './global/App';
import Visor from 'modAws/Visor';
import Presentacion from 'modAws/paginas/Presentacion';
import GuiaAcceso from 'modAws/guia/GuiaAcceso';
const container = document.getElementById('rootPage');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
// Paginas sin menus (las dos primeras son publicas, sin login):
//   /Aws/Compartido/<token>  diagrama compartido de solo lectura
//   /Aws/Producto            presentacion comercial para enviar a un cliente
//   /Aws/Guia                guia visual de servicios (pestaña nueva, ocupa toda la ventana). NO es publica: pide sesion y guarda el progreso en la cuenta (GuiaAcceso)
const ruta = window.location.pathname;
const compartido = /^\/Aws\/Compartido\/([A-Za-z0-9_-]{43})\/?$/.exec(ruta);
const producto = /^\/Aws\/Producto\/?$/.test(ruta);
const guia = /^\/Aws\/Guia\/?$/.test(ruta);
root.render(compartido ? <Visor token={compartido[1]} /> : producto ? <Presentacion publico /> : guia ? <GuiaAcceso /> : <App tab="home" />);
